module.exports = __webpack_public_path__ + "img/bg-bottom-left2.e4205b11.png";